export enum ESaleRequestType {
  SALEREQUEST = 'single',
  MULTIREQUEST = 'multi',
}
